<template>
  <v-container
    v-if="resolved"
    id="org-details"
    tag="section"
  >
    <orgs-detail-header
      :org-details="orgData"
      :resolved="resolved"
    />
    <v-row v-if="isInternal">
      <v-col>
        <div class="float-right">
          <v-btn
            v-if="isInternal"
            color="secondary"
            class="icon-btn"
            @click="confirmOrgDelete"
          >
            <font-awesome-icon icon="trash-alt" />
            Delete Organization
          </v-btn>
          <div style="clear:both" />
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-card class="px-0 mx-11">
          <v-tabs
            v-model="activeTab"
            background-color="transparent"
          >
            <v-tabs-slider color="muted" />
            <valkyrie-tab
              text="Users"
              icon="$faUsers"
            />
            <valkyrie-tab
              text="Settings"
              icon="$faClipboard"
            />
            <v-tabs-items
              v-model="activeTab"
              class="transparent"
            >
              <v-tab-item class="tab-window">
                <org-users-list
                  :filter-by="'organization_id'"
                  has-filters
                />
              </v-tab-item>
              <v-tab-item class="tab-window">
                <org-settings />
              </v-tab-item>
            </v-tabs-items>
          </v-tabs>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
  import { mapGetters } from 'vuex'
  import orgDetailsRouterMixin from '@/helpers/org-details-router-mixin'
  import OrgUsersList from '@/components/orgs/OrgUsersList'
  import OrgSettings from '@/components/orgs/OrgSettings'
  import OrgsDetailHeader from '@/components/orgs/OrgsDetailHeader'
  import ValkyrieTab from '@/components/base/ValkyrieTab'

  export default {
    name: 'OrgDetailsBody',
    components: {
      OrgUsersList,
      OrgSettings,
      OrgsDetailHeader,
      ValkyrieTab,
    },
    mixins: [orgDetailsRouterMixin],
    data: () => ({
      activeTab: 0,
      resolved: false,
    }),
    computed: {
      ...mapGetters({
        currentSelectedOrg: 'Permissions/currentSelectedOrg',
        isInternal: 'Permissions/isInternal',
        orgData: 'Organizations/orgData',
        canManageOrg: 'Permissions/canManageOrg',
        totalUsers: 'Users/totalUsers',
        selectedOrg: 'Permissions/currentSelectedOrg',
      }),
      canAddProperty () {
        return this.canManageOrg(this.orgId)
      },
      orgId () {
        return this.$route.params.orgId
      },
      tabs () {
        return [
          {
            list: 'OrgUsers',
            text: `Users (${this.totalUsers})`,
            icon: '$faUsers',
          },
          {
            list: 'Settings',
            text: 'Settings',
            icon: '$faClipboard',
          },
        ]
      },
    },
    watch: {
      selectedOrg (newOrg) {
        if (newOrg) this.getOrg()
      },
    },
    created () {
      this.getOrg()
    },
    methods: {
      getOrg () {
        const payload = {
          id: this.$route.params.orgId,
          type: 'orgs',
        }
        this.$store.dispatch('Organizations/fetchOrgDetails', payload.id).then(() => {
          if (!this.currentSelectedOrg.id) this.$store.commit('Organizations/setSelectedOrg', this.orgData)
          this.resolved = true
        })
      },
      confirmOrgDelete () {
        this.$root.$confirm({
          icon: '$faTrash',
          minHeight: 510,
          width: 400,
          title: 'Delete Organization',
          text: `Are you sure you want to permanently delete the organization <span style="font-weight: bold">${this.orgData.name}</span> and all of its data?`,
          confirmText: 'Yes, delete',
          cancelText: 'cancel',
        })
          .then(() => {
            this.$store.dispatch('Organizations/deleteOrg', this.orgData.id)
          })
      },
    },
  }
</script>
<style lang="scss">
#org-details {
  .text-start {
    max-height: 40px !important;
    width:250px;
    max-width:300px;
    padding: 10px !important;
  }
  .v-card--material__heading {
    .v-icon.v-icon {
      font-size: 16px !important;
    }
  }
  .panel-col {
    max-width:200px;
  }
  .panel-row {
    margin-top: 20px;
  }
  .svg-inline--fa {
    height: 1.1rem;
    width: 1.1rem;
  }
  .tab-window {
    margin-top: -2px;
    border-top: 2px solid #9797976c;
  }
  .v-tabs-items {
    .v-sheet.v-card:not(.v-sheet--outlined) {
      box-shadow: unset;
    }
  }
}
</style>
